import { useRef } from 'react';
import { PopoverButton } from '@headlessui/react';
import { Icon } from '@fm-nx/svg';
import classNames from 'classnames';
import slugify from '@sindresorhus/slugify';

type MainNavLinkMenuProps = {
    title: string | string[];
    isActiveSection: boolean;
    isMenuOpenThis: boolean;
    onClick: () => void;
    onClickOutside?: () => void;
    isDark: boolean;
};

const MainNavLinkMenu = (props: MainNavLinkMenuProps) => {
    const { title, isActiveSection, isMenuOpenThis, onClick, isDark } = props;
    const buttonRref = useRef(null);
    const isHighlighted = isMenuOpenThis;
    // useClickOutside({ ref: buttonRref, onClickOutside: () => onClickOutside && onClickOutside() });

    const textClasses = classNames({
        'text-green-400': isHighlighted,
        'text-white': !isHighlighted && isDark,
        'text-gray-900': !isHighlighted && !isDark,
    });
    const borderClasses = classNames({
        'after:bg-green-400': isHighlighted,
        'after:bg-white': !isHighlighted && isDark,
        'after:bg-gray-900': !isHighlighted && !isDark,
    });

    const getCaretColor = () => {
        if (isHighlighted) {
            return 'chartreuse';
        }
        if (isDark) {
            return 'white';
        }
        return 'black';
    };

    return (
        <PopoverButton
            ref={buttonRref}
            onClick={() => {
                onClick();
            }}
            className={`${textClasses}
                cursor-pointer
                duration-200
                ease-in-out
                font-bold
                font-headline
                leading-[1.4]
                mb-0
                no-underline
                text-sm
                tracking-[2.24px]
                transition-colors
                uppercase
            `}
        >
            <div className="flex items-center">
                <span
                    className={`${borderClasses} ${
                        isActiveSection || isHighlighted ? 'after:w-full' : ''
                    } border-b-in flex flex-row lg:flex-col xl:flex-row`}
                >
                    {Array.isArray(title)
                        ? title.map((line, index) => (
                              <span
                                  className={classNames(`text-nowrap`, {
                                      'pl-0 xl:pl-2': index > 0,
                                  })}
                                  key={slugify(line)}
                              >
                                  {line}
                              </span>
                          ))
                        : title}
                </span>
                <div className="flex items-center">
                    <Icon name="caret" size="sm" color={getCaretColor()} direction={isMenuOpenThis ? 'up' : 'down'} />
                </div>
            </div>
        </PopoverButton>
    );
};

export default MainNavLinkMenu;
